import React from 'react';
import { makeStyles, Table, TableRow } from '@material-ui/core';
import { BoxWrapper } from 'components/Base';
import TableComponents from 'components/Table';
import { FundType } from 'store/modules/Funds/types';
import Fields from 'components/Fields';
import { formatPercent } from 'utils';

const useStyles = makeStyles({
  cipFunds: {
    marginTop: '1rem'
  }
});

interface CipTableProps {
  cipFunds: Array<FundType>;
  toggleCipFund: (fund: any) => void;
  fundsAdded: Array<FundType>;
}

const CipTable = ({ cipFunds, toggleCipFund, fundsAdded }: CipTableProps) => {
  const classes = useStyles();
  return (
    <BoxWrapper title="Approved CIP funds" className={classes.cipFunds}>
      <Table style={{ backgroundColor: '#fff' }}>
        <TableComponents.TableHead
          cells={[
            '',
            'Fund',
            'Sector',
            'OCF',
            'Transaction cost',
            'Total fund charge',
            '1yr',
            '3yr',
            '5yr'
          ]}
        />
        <TableComponents.TableBody>
          {cipFunds.map((fund: FundType, index: number) => {
            const totalFundCharge =
              Number(fund.trading_costs) + Number(fund.ocf);
            const convertToPercent = (val: string | number) =>
              Number(val) * 100;

            const isAlreadyAdded = fundsAdded.some((addedFund: any) => {
              const isModelPortfolio = addedFund.model_portfolio;
              if (isModelPortfolio) return false;

              return addedFund.fund.id === fund.id;
            });

            return (
              <TableRow key={index}>
                <TableComponents.TableCell>
                  <Fields.CheckboxCustom
                    isChecked={isAlreadyAdded}
                    onChange={() => {
                      toggleCipFund(fund);
                    }}
                  />
                </TableComponents.TableCell>
                <TableComponents.TableCell>
                  {fund.name}
                </TableComponents.TableCell>
                <TableComponents.TableCell>
                  {fund.sector_name || '-'}
                </TableComponents.TableCell>
                <TableComponents.TableCell>
                  {formatPercent(convertToPercent(fund.ocf))}
                </TableComponents.TableCell>
                <TableComponents.TableCell>
                  {formatPercent(convertToPercent(fund.trading_costs))}
                </TableComponents.TableCell>
                <TableComponents.TableCell>
                  {formatPercent(convertToPercent(totalFundCharge))}
                </TableComponents.TableCell>
                <TableComponents.TableCell>
                  {fund.one_y_performace
                    ? formatPercent(
                        convertToPercent(fund.one_y_performace),
                        true
                      )
                    : '-'}
                </TableComponents.TableCell>
                <TableComponents.TableCell>
                  {fund.three_y_performace
                    ? formatPercent(
                        convertToPercent(fund.three_y_performace),
                        true
                      )
                    : '-'}
                </TableComponents.TableCell>
                <TableComponents.TableCell>
                  {fund.five_y_performace
                    ? formatPercent(
                        convertToPercent(fund.five_y_performace),
                        true
                      )
                    : '-'}
                </TableComponents.TableCell>
              </TableRow>
            );
          })}
        </TableComponents.TableBody>
      </Table>
    </BoxWrapper>
  );
};

export default CipTable;
